import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  name: Yup.string().required("Account Name is required"),
  country: Yup.string().required("Country is required"),
  localTimeZone: Yup.string().required("Time Zone is required")
});
